import capsule from "../../images/technology/image-space-capsule-landscape.jpg";
import vehicle from "../../images/technology/image-launch-vehicle-landscape.jpg";
import spaceport from "../../images/technology/image-spaceport-portrait.jpg";
export const data = [
  {
    img: `${vehicle}`,
    terminology: "Launch vehicle",
    text: " A launch vehicle or carrier rocket is a rocket-propelled vehicle used to carry a payload from Earth's surface to space, usually to Earth orbit or beyond. Our WEB-X carrier rocket is the most powerful in operation. Standing 150 metres tall, it's quite an awe-inspiring sight on the launch pad!",
  },
  {
    img: `${spaceport}`,
    terminology: "Spaceport",
    text: "A spaceport or cosmodrome is a site for launching (or receiving) spacecraft, by analogy to the seaport for ships or airport for aircraft. Based in the famous Cape Canaveral, our spaceport is ideally situated to take advantage of the Earth’s rotation for launch.",
  },
  {
    img: `${capsule}`,
    terminology: "Space capsule",
    text: "A space capsule is an often-crewed spacecraft that uses a blunt-body reentry capsule to reenter the Earth's atmosphere without wings. Our capsule is where you'll spend your time during the flight. It includes a space gym, cinema, and plenty of other activities to keep you entertained.",
  },
];
